import React from 'react';
import PropTypes from 'prop-types';
import ReportIssueBase from '../reportIssue/ReportIssueBase';

const NotReceived = ({ ...props }) => {
  const { mobile, motiveId, product, type, profile, onData } = props;

  return (
    <ReportIssueBase
      mobile={mobile}
      motiveId={motiveId}
      product={product}
      type={type}
      profile={profile}
      onData={onData}
      name="NotReceived"
      label="Cuéntanos el inconveniente"
      buttonText="Enviar autorización"
    />
  );
};

NotReceived.propTypes = {
  mobile: PropTypes.bool,
  motiveId: PropTypes.string,
  type: PropTypes.string,
  product: PropTypes.object,
  profile: PropTypes.object,
  onData: PropTypes.func,
};

export default NotReceived;
